import { PageStepper } from "@wayflyer/flyui";

const ONBOARDING_STEPS = [
  "Business Information",
  "Contact Details",
  "Monthly Revenue",
  "Funding Details",
  "Connections and Data",
  "Application Review",
];

export const OnboardingStepper = ({ currentStep }: { currentStep: number }) => {
  return <PageStepper currentIndex={currentStep} steps={ONBOARDING_STEPS} maxVisibleSteps={ONBOARDING_STEPS.length} />;
};
